import { createRelayResource } from '@townsquare/relay-utils';

import TopicPageAsideQuery, {
	type TopicPageAsideQuery as TopicPageAsideQueryQueryType,
} from '../ui/__generated__/TopicPageAsideQuery.graphql';

export const topicAsideResource = createRelayResource<TopicPageAsideQueryQueryType>({
	getQuery: (routerContext) => {
		const uuid = routerContext.match.params.uuid ?? '';

		return {
			query: TopicPageAsideQuery,
			variables: {
				tagUuid: uuid,
			},
		};
	},
});
